import { Component } from '@angular/core';
import { AuthService } from '../../../Shared/Services/auth.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { NgxSpinnerService } from 'ngx-spinner';
import { OrdersService } from '../../../Services/orders.service';
import { environment } from '../../../../environments/environment'
import { AddOrderPricingComponent } from '../add-order-pricing/add-order-pricing.component';
import { DtoGroupCategoryWithProductVM } from '../../../Model/orders/DtoGroupCategoryWithProductVM';
import { DtoProductsVM } from '../../../Model/price-list/DtoProductsVM';
import { SharedService } from '../../../Shared/Services/shared.service';
import { Router } from '@angular/router';
import { UserType } from '../../../Shared/Enums/UserType';
import { IngredientInfoVM } from '../../../Model/cost-calculation/MakeSectorsOrder/IngredientInfoVM';
import { OrderInfoVM } from '../../../Model/orders/OrderInfoVM';
import * as arabicStrings from '@flowdegree/arabic-strings';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../../Shared/Services/dialog.service';

@Component({
  selector: 'app-order-pricing',
  templateUrl: './order-pricing.component.html',
  styleUrl: './order-pricing.component.scss'
})
export class OrderPricingComponent {
  imgPath: string = environment.ImgUrl;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  GroupCategoryWithProduct: DtoGroupCategoryWithProductVM[] = [];
  OriginalGroupCategoryWithProduct: DtoGroupCategoryWithProductVM[] = [];
  productsList: DtoProductsVM[] = [];
  showProductsList: boolean = false;
  isTabs: boolean = true;
  selectedCategory?: DtoProductsVM | null = null;
  IsViewOrder: boolean = false;
  ProductAddedDetailsId: number[] = [];
  OrderProductsInfo: IngredientInfoVM[] = [];
  OnlyQuantity: boolean = false;
  ValidationErrors: string[] = [];

  constructor(private api: OrdersService, private auth: AuthService, private router: Router, private translateService: TranslateService,
    private spinner: NgxSpinnerService, private dialogService: DialogService, private shared: SharedService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Agent])) {
      this.spinner.show();
      this.GetParenrCategorywithProduct();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetParenrCategorywithProduct() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Agent])) {
      this.api.GetParenrCategorywithProduct()
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: any) => {
          let filtedData = res.payload.filter((a: DtoGroupCategoryWithProductVM) => a?.listCategory?.length ?? 0 > 0);
          this.GroupCategoryWithProduct = filtedData;
          this.OriginalGroupCategoryWithProduct = filtedData;
          this.isTabs = this.GroupCategoryWithProduct.length == 2;

          //select first and open ites produscts
          this.SelectFirstCategory(filtedData);
          this.spinner.hide();
        });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  SelectFirstCategory(filtedData: DtoGroupCategoryWithProductVM[]) {
    filtedData.map((a: DtoGroupCategoryWithProductVM) => {
      a.listCategory?.forEach((element: DtoProductsVM) => {
        if (this.selectedCategory == null) {
          this.selectedCategory = element;
          this.ShowProducts(element);
        }
      });
    });
  }

  GetProducts(products: DtoProductsVM[]) {
    this.productsList = products;
    this.showProductsList = true;
  }

  ShowProducts(category: any) {
    this.selectedCategory = category.categoryName;
    this.productsList = [];
    this.showProductsList = true;
    var GroupCategoryWithProduct = this.GroupCategoryWithProduct.map((p: DtoGroupCategoryWithProductVM) => p.listCategory);
    GroupCategoryWithProduct.map((p: any) => {
      p.filter((a: any) => a.id == category.id).map((p: any) => {
        p.products.forEach((element: DtoProductsVM) => {
          this.productsList.push(element);
        });
      });
    });
  }

  CalcPrice(pricePerOne?: number, discount?: number): number {
    return this.shared.CalcPriceByDiscount(pricePerOne, discount);
  }

  tabClick(tab: any) {
    if (tab.index == 0) {
      this.OnlyQuantity = false;
    }
    else if (tab.index == 1) {
      this.OnlyQuantity = true;
    }
  }

  openDialog(obj: any): void {
    const dialog = this.dialogService.openDialog(AddOrderPricingComponent, {
      data: { productData: obj, OnlyQuantity: this.OnlyQuantity }
    });

    dialog.afterClosed().subscribe(result => {
      this.AddOrderDetails(result?.data, result?.productData);
      this.ValidationErrors = [];
    });
  }

  GetOrderInfoVM(data: any, selectedProduct?: DtoProductsVM): IngredientInfoVM {
    const productCost = this.CalcPrice(selectedProduct?.pricePerOne, selectedProduct?.descount);
    const totalRollsCost = (data?.numRollsUsed * productCost);
    const totalIronCost = (data?.numRollsUsed * 90);
    let Product: OrderInfoVM = {
      numRollsUsed: data?.numRollsUsed,
      numIronUsed: data?.numIronUsed,
      totalRollsCost: totalRollsCost,
      totalIronCost: totalIronCost,
      totalCost: (totalRollsCost + totalIronCost),
      productId: selectedProduct?.id,
      productName: selectedProduct?.name,
      colorName: selectedProduct?.colorName,
      descount: selectedProduct?.descount,
      haveIron: (selectedProduct?.numberIron ?? 0) > 0,
      imgURL: selectedProduct?.imgURL,
      pricePerMeter: selectedProduct?.pricePerMeter,
      pricePerOne: selectedProduct?.pricePerOne,
      totalOrder: selectedProduct?.totalQuota
    };

    return Product;
  }

  AddOrderDetails(data: any, selectedproductData?: DtoProductsVM) {
    if (selectedproductData) {
      let Product: OrderInfoVM = this.GetOrderInfoVM(data, selectedproductData);
      this.OrderProductsInfo?.push(Product);
      this.ProductAddedDetailsId?.push(selectedproductData?.id!);
    }
  }

  ViewOrder() {
    this.ValidationErrors = [];
    if (this.OrderProductsInfo?.length > 0) {
      this.IsViewOrder = true;
    }
    else {
      this.ValidationErrors = [this.GetErrorMsg("PriceOrdersFirst")];
    }
  }

  GetErrorMsg(key: any) {
    let msg: string = "";
    this.translateService.get(key).subscribe((translation: any) => {
      msg = translation;
    });

    return msg;
  }

  checkSearchVal(searchVal?: any) {
    //this.GroupCategoryWithProduct = this.shared.checkSearchVal(this.GroupCategoryWithProduct, this.OriginalClients, searchVal, 'name');

    var listCategory = this.GroupCategoryWithProduct.map((p: DtoGroupCategoryWithProductVM) => p.listCategory);


    // searchVal = arabicStrings.sanitize(searchVal!);

    // this.GroupCategoryWithProduct.slice();
    // const filtered: any[] = [];
    // if (searchVal && searchVal !== '') {
    //   for (const selected of this.GroupCategoryWithProduct) {
    //     let filter = selected?.listCategory?.filter(a => a.categoryName?.toLowerCase());
    //     if (arabicStrings.sanitize(filter!).search(searchVal?.toLowerCase()) !== -1) {
    //       filtered.push(selected.listCategory);
    //     }
    //   }

    //   if (filtered?.length > 0) {
    //     this.GroupCategoryWithProduct = filtered.slice();
    //   }
    //   else {
    //     this.GroupCategoryWithProduct = [];
    //   }
    // }

    // this.GroupCategoryWithProduct = this.OriginalGroupCategoryWithProduct;
  }

  CheckIsViewOrder(IsViewOrder: boolean) {
    this.OrderProductsInfo = [];
    this.ProductAddedDetailsId = [];
    this.IsViewOrder = IsViewOrder;
  }
}
